export enum BaleStatusEnum {
    OPEN = 'OPEN',
    INPROGRESS = 'INPROGRESS',
    CLOSED = 'CLOSED',
    
}